
<script lang="ts" setup>
// Packages

// --------------------------------------------------------------------
// Composables
// --------------------------------------------------------------------

const { data: categories } = await useAsyncData(
  'blog_categories', 
  () => $fetch('/api/blog/categories?per_page=50'),
);

const route = useRoute();


// --------------------------------------------------------------------
// State
// --------------------------------------------------------------------

const searchText = ref('');
const timer = ref<NodeJS.Timeout>();

watch([searchText], () => {
  if (timer.value) {
    clearTimeout(timer.value);
  }

  timer.value = setTimeout(() => {
    navigateTo(searchText.value.length ? `/blog?title=${searchText.value}` : '/blog');
  }, 800);
});

watch([route], () => {
  if (route.query.title) {
    searchText.value = route.query.title as string;
  }
}, { deep: true });

onMounted(() => {
  if (route.query.title) {
    searchText.value = route.query.title as string;
  }
})

</script>
<template>
  <div class="block filter p-5 bg-white lg:after:sticky top-0">
    <!-- Search -->
    <div class="block mb-8 p-8 search-filter-input">
      <span class="font-bold my-4 block text-xl">
        {{ $t('SEARCH') }}
      </span>
      <input
        v-model="searchText"
        name="search"
        :placeholder="$t('TYPE_TO_SEARCH')"
        type="text"
        class="w-full border border-gray-400 p-2 outline-none"
      >
    </div>

    <div class="block my-8">
      <span class="font-bold my-4 block text-xl">
        {{ $t('CATEGORY') }}
      </span>

      <ul class="list-disc pl-4" v-if="categories">
        <li
          :class="{ 'font-bold': route.query.category === category.slug, 'underline': route.query.category === category.slug }"
          class="hover:underline cursor-pointer"
          v-for="category in categories"
          :key="category.id"
        >
          <nuxt-link :to="`/blog?category=${category.slug}&category_n=${category.name}`">
            {{ category.name }}
          </nuxt-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<style lang="scss">
.filter {
  width: 100%;
}

@media (screen(xl)) {
  .filter {
    width: 410px;
  }
}

.search-filter-input {
  background-color: rgba(var(--theme-rgb), 0.065);
  border-radius: 8px;
}
</style>